/**
 * @module use-cases/sections/slice
 * @desc Sections Slice (Reducers and ExtraReducers)
 *
 */

import { createSlice } from 'core/use-cases/utilities';
import { Utilities } from 'core/domains';
import type { Content } from 'core/domains';

import * as actions from './actions';
import { initialState } from './initial-state';

const sectionsSlice = createSlice({
  name: 'sections',
  initialState,
  reducers: {},

  extraReducers: (builder) => {
    builder.addCase(actions.sectionsCleanUp, (state, { payload }) => {
      if (payload && state[payload]) {
        state[payload] = {
          data: {} as Content[number]['data'],
          message: '',
          status: Utilities.STATUS.IDLE,
          updatedAt: 0,
        };
      }
    });

    builder.addCase(actions.sectionsFetch.request, (state, { payload }) => {
      if (payload) {
        state[payload] = {
          data: {} as Content[number]['data'],
          message: '',
          status: Utilities.STATUS.RUNNING,
          updatedAt: 0,
        };
      }
    });

    builder.addCase(actions.sectionsFetch.success, (state, { meta, payload }) => {
      const { payload: type } = meta;

      if (type) {
        state[type] = {
          data: payload,
          message: '',
          status: Utilities.STATUS.SUCCESS,
          updatedAt: meta.updatedAt,
        };
      }
    });

    builder.addCase(actions.sectionsFetch.failure, (state, { error, meta }) => {
      if (meta && meta.payload) {
        const { payload: type } = meta;
        const { message } = error;

        state[type].status = Utilities.STATUS.ERROR;
        state[type].message = message;
      }
    });
  },
});

export const { reducer } = sectionsSlice;
export { actions };
